import React from 'react';
import Avatar from 'react-avatar';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useLogout } from '../context/LogoutContext';

const RightDivTop = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const navigate = useNavigate();
    const { setIsLoggingOut } = useLogout();

    const confirmedLogout = (e) => {
        e.preventDefault();
        confirmAlert({
            title: 'Confirm to logout',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => logout()
                },
                {
                    label: 'No',
                    onClick: () => console.log("no")
                }
            ]
        });
    };

    const logout = () => {
        setIsLoggingOut(true);
        localStorage.removeItem("user");
        localStorage.removeItem("jwt");
        navigate("/");
    };

    return (
        <div>
            <div className='flex justify-between items-center bg-[#060c18] text-white px-4 py-4'>
                Welcome Back!
                <div className='flex items-center space-x-2'>
                    <div>
                        <p className='text-right font-semibold'>{user.shop.name} ( {user.shop.branch} )</p>
                    </div>
                    <Avatar className='cursor-pointer' onClick={confirmedLogout} name={user.full_name} size='30' round='50px' color='#0da538' />
                </div>
            </div>
        </div>
    );
};

export default RightDivTop;
